export default {"src":"/_next/static/media/PillerCoinRotating.b8dda1e3.gif","height":468,"width":820,"blurWidth":0,"blurHeight":0};